import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { useProductListingStyle } from 'bpm/pages/ProductsPage/ProductListingsPage/ProductLisitngsPage.styles'
import { processEnv } from 'components/configuration/environmentVariables'
import React from 'react'
import { Link } from 'react-router-dom'
import { TVData } from '../../ProductCardManagementPage.types'

const ProductNameCell = ({ row }: TVData) => {
    const classes = useProductListingStyle({})
    const listingId = row.original?.listingId
    const text = !!row.original
        ? row.original.productName
            ? row.original.productName
            : 'No product name'
        : ''

    const productPage =
        processEnv.REACT_APP_ShowUpdatedProductListings !== '1'
            ? 'product-card-management'
            : 'products'

    const productDetailPath = !!listingId
        ? `/bpm/${productPage}/product/listing/${listingId}`
        : `/bpm/${productPage}/all`

    return (
        <HoverTooltip text={text}>
            <Link
                to={{
                    pathname: productDetailPath,
                    search: '?showBackButton=false',
                }}
                className={classes.productNameText}
                target="_blank"
                style={{
                    textDecoration: 'none',
                }}
            >
                {text}
            </Link>
        </HoverTooltip>
    )
}

export default ProductNameCell
